// Footer get-in-touch accordion
document.querySelectorAll('.get-in-touch').forEach((item) => {
  item.addEventListener('click', () => {
    item.closest('.group-block-content').classList.toggle('is-open');
  });
});

// Move newsletter outside get-in-touch-wrapper
document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  const newsletter = document.querySelector('.get-in-touch-wrapper .newsletter_info');
  const footerLogoColumn = document.querySelector('.footer-logo-column');

  if (!newsletter || !footerLogoColumn) return;

  // Remove newsletter from get-in-touch-wrapper
  // and add it at the bottom of footer-logo-column
  footerLogoColumn.appendChild(newsletter);
});

// searchbar

  document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.predictive-search');
    const input = document.querySelector('.search-input');
    const wrapper = document.querySelector('.predictive-search-form__content-wrapper');

    if (!container || !input || !wrapper) return;

    input.addEventListener('click', function (e) {
      e.stopPropagation();
      wrapper.classList.add('is-open');
    });

    document.addEventListener('click', function (e) {
      if (!container.contains(e.target)) {
        wrapper.classList.remove('is-open');
      }
    });
  });


  document.addEventListener("click", function (event) {
    const target = event.target.closest(".loyalty-faqs .faq-question");
    if (!target) return;
    const nextElem = target.nextElementSibling;
    if (!nextElem) return;
    const isOpen = target.classList.contains("active");
    if (isOpen) {
      // Close
      nextElem.style.maxHeight = null;
      target.classList.remove("active");
    } else {
      // Open
      nextElem.style.maxHeight = nextElem.scrollHeight + "px";
      target.classList.add("active");
    }
  });

  //	Insurance Popup  
$(document).ready(function() {
    $(document).on('click', '.ins-more-info', function(e) {
      e.preventDefault();
      const popup = document.querySelector('.insurance-info-content');
      if (!popup) return;
      popup.classList.add('active-ins-popup');
      if (!popup.open) {
        popup.showModal();
      }
      let maxHeight = 0;
      $('.ins-box-info').removeAttr('style');
      $('.ins-box-info').each(function() {
        const currentHeight = $(this).outerHeight();
        if (currentHeight > maxHeight) {
          maxHeight = currentHeight;
        }
      });
      $('.ins-box-info').height(maxHeight);
    });

    $(document).on('click', '.ins-modal-close', function(e) {
      e.preventDefault();
      const popup = document.querySelector('.insurance-info-content');
      if (!popup) return;
      popup.classList.remove('active-ins-popup');
      if (popup.open) {
        popup.close();
      }
    });

    $(document).on('click', '.insurance-info-content', function(e) {
      const popup = this;
      const modal = popup.querySelector('.insurance-info-modal');
      if (!modal) return;
      const rect = modal.getBoundingClientRect();
      const clickedOutside =
        e.clientX < rect.left ||
        e.clientX > rect.right ||
        e.clientY < rect.top ||
        e.clientY > rect.bottom;
      if (clickedOutside) {
        popup.classList.remove('active-ins-popup');
        if (popup.open) {
          popup.close();
        }
      }
    });
    if ($(window).width() < 768) {
      $('.ins-category-box').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }

    window._klOnsite = window._klOnsite || [];
    $('.button[data-download="download"]').click(function(e) {
      event.preventDefault();
      var pdf_url = $(this).parent('.p_div').attr('pdf_url');
      var heading = $(this).parent('.p_div').attr('heading');
      window.PDFURL = pdf_url;
      window.DOWNLOADHEADING = heading;
    //   console.log(heading)
      if (window.innerWidth > 768) {
          window._klOnsite.push(['openForm', 'TsVaNb']);
      } else {
          window._klOnsite.push(['openForm', 'TeGpTB']);
      }
    });
});